<template>
  <div id="index">
    <food-form @onMessage='onMessage'></food-form>
  </div>
</template>

<script>
import FoodForm from '@/components/form/FoodForm.vue'
export default {
  name: 'EditFood',
  methods: {
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  components: {
    FoodForm
  },
  head: {
    title () {
      return {
        inner: '食品情報登録',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '食品情報の登録ページ'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>